
// npm
import {Map as ImmutableMap} from 'immutable'

// redux (action-types)
import * as ACTION_TYPES from './action-types'


const CACHED_PDFS_REDUCER = (state=ImmutableMap(), action) =>
{
	switch (action.type)
	{
		case ACTION_TYPES.CACHE_PDF:
			return state.set(action.pdfUrl, action.blobUrl);
		default:
			return state;
	}
}


export {CACHED_PDFS_REDUCER}